<script lang="ts" setup>
    import { computed } from 'vue';
    import { storeToRefs } from "pinia";
    import { useGenericStore } from "@/store/genericStore";

    let props = defineProps({
        bg_color: {
            type: String,
            default: 'rothcoWhite'
        },
        text_color: {
            type: String,
            default: 'rothcoBlack'
        },
        seoText: {
            type: String,
            required: true
        },
        category: {
            type: Object
        },
        builderContext: {
            type: Object
        }
    });

    const bgColorClass = computed(()=>{
        return `bg-${props.bg_color || 'rothcoWhite'}`
    });

    const textColorClass = computed(()=>{
        return `text-${props.text_color || 'rothcoBlack'}`
    });

    const categorySeoName = computed(()=>{
        return props.builderContext?.content?.data?.category.seo_name ?? props.category?.seo_name ?? '';
    })

    const { state:categoryDataStore} = storeToRefs(useGenericStore(`categoryData-${categorySeoName.value}`));

</script>
<template>
    <div :class="['seocopy category-landing', bgColorClass]">
        <div class="seocopy-content">
            <p :class="['paragraph', textColorClass]" style="text-align: center">{{  props.seoText || categoryDataStore?.value?.seoText }}</p>
        </div>
    </div>
</template>
